import moment from "moment";

import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { useDispatch } from "react-redux";

// Core
import MDCLabel from "../../../core/MDCLabel";
import ErrorText from "../../../shared/ErrorText";
import MDCButton from "../../../core/MDCButton";
import MDCTooltip from "../../../core/MDCTooltip";

// Icons
import DownloadFileIcon from "../../../iconComponents/DownloadFileIcon";
import CrossedIcon from "../../../iconComponents/CrossedIcon";
import FileIcon from "../../../iconComponents/FileIcon";

// Actions
import { csvImportExportAction } from "../../../../store/actions/exportImportFile/csvImportExportAction";

// Helpers
import { getFileNameFromHttpResponse } from "../../../../helpers/utils";

const useStyles = makeStyles(() => ({
  buttonStyle: {
    width: "100%",
  },
  dateTimeStyle: {
    fontSize: "0.875rem",
  },
  fileNameCsv: {
    marginRight: "0.5rem",
  },
  fileNameSingleLine: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    lineClamp: 1,
  },
  errorFileContainer: {
    display: "flex",
    width: "29rem",
    marginTop: "0.5rem",
    padding: "1rem",
    backgroundColor: "#E6E6E64D",
    borderRadius: "4px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    lineClamp: 1,
  },
}));

const CsvUploadAndErrorDetails = ({ uploadDetails, index, isError }) => {
  const dispatch = useDispatch();

  const {
    buttonStyle,
    dateTimeStyle,
    fileNameCsv,
    fileNameSingleLine,
    errorFileContainer,
  } = useStyles();

  // Download CSV File
  const handleBlobData = (fileData, fileName) => {
    const url = window.URL.createObjectURL(
      new Blob([fileData], { type: "text/csv" })
    );

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  };

  // Todo inputFilesCount  replace with filesCount once api is ready

  return (
    <div key={index}>
      <Grid container>
        <Grid item xs={6}>
          {isError ? (
            <MDCLabel
              label={`${uploadDetails?.inputFilesCount} Datei(en) hochgeladen`}
            />
          ) : (
            <MDCLabel
              label={`Lade ${uploadDetails?.inputFilesCount} Datei(en) hoch`}
            />
          )}
        </Grid>

        <Grid item xs={6} display="flex" justifyContent="flex-end">
          <div className={dateTimeStyle}>
            <MDCLabel
              label={
                uploadDetails?.processDate
                  ? `${moment(uploadDetails?.processDate).format(
                      "DD.MM.YYYY HH:mm"
                    )} uhr`
                  : ""
              }
            />
          </div>
        </Grid>
      </Grid>

      {isError && (
        <>
          {uploadDetails?.errorFiles?.length > 0 &&
            uploadDetails?.errorFiles?.map((file, index) => (
              <MDCTooltip key={`${file}-${index}`} title={file}>
                <div className={errorFileContainer}>
                  <span className={fileNameCsv}>
                    <FileIcon />
                  </span>
                  <span className={fileNameSingleLine}>{file}</span>
                </div>
              </MDCTooltip>
            ))}
        </>
      )}

      {isError && (
        <>
          <ErrorText error="Einige Zeilen aus den CSVs wurden nicht importiert." />

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <MDCButton
                className={buttonStyle}
                variant="outlined"
                size="small"
                label="Fehlerdatei exportieren"
                startIcon={<DownloadFileIcon />}
                onClick={() =>
                  dispatch(
                    csvImportExportAction.getDocumentImportCSVErrorFile(
                      uploadDetails?.csvUploadId
                    )
                  ).then((resp) => {
                    const fileData = resp?.data;
                    const fileName = getFileNameFromHttpResponse(resp);
                    handleBlobData(fileData, fileName);
                  })
                }
              />
            </Grid>

            <Grid item xs={6}>
              <MDCButton
                className={buttonStyle}
                variant="outlined"
                size="small"
                label="Schließen & Ignorieren"
                startIcon={<CrossedIcon />}
                onClick={() =>
                  dispatch(
                    csvImportExportAction.closeAndIgnoreCsvDownload(
                      uploadDetails?.csvUploadId
                    )
                  ).then(() => {
                    dispatch(
                      csvImportExportAction.getCSVUploadedAndErrorFile()
                    );
                  })
                }
              />
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default CsvUploadAndErrorDetails;
